(function () {
  'use strict';
  if (window.__amazearEvents) return;
  window.__amazearEvents = true;
  const pendingKey = 'amazear-contact-pending-v1';
  const maxAge = 15 * 60 * 1000;
  const topics = ['general', 'product', 'wholesale', 'oem_odm'];
  const markets = {'www.amazon.com':'us','www.amazon.co.uk':'uk','www.amazon.de':'de','www.amazon.co.jp':'jp','www.amazon.ca':'ca','www.amazon.fr':'fr','www.amazon.it':'it','www.amazon.es':'es','www.amazon.com.au':'au','www.amazon.nl':'nl','www.amazon.se':'se','www.amazon.pl':'pl','www.amazon.com.be':'be','www.amazon.ie':'ie','www.amazon.com.mx':'mx','www.amazon.com.br':'br'};
  const analytics = () => window.AmazearAnalytics;
  const allowed = () => Boolean(analytics() && analytics().isAllowed());
  const track = (name, parameters) => Boolean(analytics() && analytics().track(name, parameters));
  const clear = () => { try { sessionStorage.removeItem(pendingKey); } catch (_) {} };
  const pending = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(pendingKey));
      const age = value && Date.now() - value.at;
      return value && age >= 0 && age < maxAge ? value : null;
    } catch (_) { return null; }
  };
  const save = value => { try { sessionStorage.setItem(pendingKey, JSON.stringify(value)); } catch (_) {} };
  const flush = () => {
    const value = pending();
    if (!value) return;
    const success = document.querySelector('[data-amazear-contact-success]');
    if (success && success.dataset.amazearContactSuccess === value.formType) {
      value.confirmed = true;
      save(value);
    }
    if (!value.confirmed || (!success && !/\/pages\/inquiry-success\/?$/.test(window.location.pathname))) return;
    const name = value.formType === 'inquiry' ? 'generate_lead' : 'support_request_sent';
    const parameters = {method:'contact_form', form_type:value.formType, inquiry_type:value.topic};
    if (value.productHandle) parameters.product_handle = value.productHandle;
    if (track(name, parameters)) clear();
  };
  const onClick = event => {
    if (event.defaultPrevented || (event.type === 'auxclick' ? event.button !== 1 : event.button !== 0)) return;
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    const widget = link.closest('[data-amazon-product-handle]');
    const asin = url.pathname.match(/\/(?:dp|gp\/product)\/([A-Z0-9]{10})(?:\/|$)/i);
    if (widget && markets[url.hostname] && asin) {
      track('amazon_outbound_click', {product_id:widget.dataset.amazonProductId, product_handle:widget.dataset.amazonProductHandle, sku:widget.dataset.amazonSku, amazon_market:markets[url.hostname], asin:asin[1].toUpperCase(), button_position:widget.dataset.amazonPlacement, link_domain:url.hostname});
    } else if (url.origin === window.location.origin && /\/pages\/inquiry\/?$/.test(url.pathname)) {
      const topic = url.searchParams.get('topic');
      track('inquiry_entry_click', {inquiry_type:topics.includes(topic) ? topic : 'general', button_position:link.dataset.inquiryPlacement || (link.closest('footer') ? 'footer' : (url.searchParams.has('product') ? 'product' : 'page'))});
    }
  };
  document.addEventListener('click', onClick);
  document.addEventListener('auxclick', onClick);
  document.addEventListener('submit', event => {
    const form = event.target;
    const container = form.closest && form.closest('[data-amazear-contact-type]');
    if (!container || event.defaultPrevented || !allowed()) return;
    const topic = form.querySelector('[data-inquiry-topic]');
    const productHandle = form.dataset.inquiryProductHandle || '';
    save({at:Date.now(), formType:container.dataset.amazearContactType, topic:topic && topics.includes(topic.value) ? topic.value : 'general', productHandle:/^[a-z0-9][a-z0-9-]{0,199}$/.test(productHandle) ? productHandle : ''});
  });
  document.addEventListener('amazear:analytics-ready', flush);
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) clear(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', flush, {once:true});
  else flush();
}());
